const ShippingPage = () => {
  return (
    <div style={{ padding: "20px", maxWidth: "700px" }}>
      <h1>Доставка</h1>
      <p>
        Від нашої майстерні до вашого дому кожен виріб проходить свій шлях
        ретельно запакованим — щоб подорож Новою Поштою пройшла без пригод.
      </p>

      <h2>Як ми відправляємо</h2>
      <p>
        Усі замовлення відправляються Новою Поштою — у відділення, поштомат
        або кур'єром, на ваш вибір. Зазвичай ми збираємо й відправляємо
        замовлення протягом 3–5 робочих днів після підтвердження — кожен
        виріб виготовляється й пакується вручну, тож просимо трохи терпіння.
      </p>

      <h2>Вартість доставки</h2>
      <p>
        Доставка оплачується за тарифами перевізника (Нова Пошта) і не
        входить у вартість товару — точну суму ви побачите під час
        отримання посилки, вона залежить від ваги, габаритів і міста
        призначення.
      </p>

      <h2>Оплата</h2>
      <p>
        Оплата — готівкою при отриманні. Після оформлення замовлення ми
        зв'яжемось із вами для підтвердження і невеликої передоплати
        (200–300 грн) — це покриває вартість пересилки, якщо клієнт
        відмовиться від посилки без поважної причини.
      </p>

      <h2>Повернення та обмін</h2>
      <p>
        Якщо товар прийшов пошкодженим або не відповідає опису — обов'язково
        зафіксуйте це разом із представником Нової Пошти при отриманні (акт
        про пошкодження) і напишіть нам, ми вирішимо питання. Товар належної
        якості, виготовлений вручну під конкретне замовлення, поверненню не
        підлягає, якщо інше не обумовлено окремо.
      </p>
    </div>
  );
};

export default ShippingPage;
